import { styled } from '@mui/material/styles'
import SvgIcon from '@mui/material/SvgIcon/SvgIcon'

export const StyledCustomIcon = styled(SvgIcon)(() => ({
  marginRight: 8,
}))
